// Generated by GitHub Copilot

/**
 * Render a reusable skeleton block for async module states.
 *
 * @param {{
 *   label?: string,
 *   headingWidth?: number,
 *   subheadingWidth?: number,
 *   cardCount?: number,
 *   rowCount?: number
 * }} props Component props.
 * @returns {JSX.Element} Skeleton fallback markup.
 */
function LoadingFallback({
  label = "Loading module",
  headingWidth = 280,
  subheadingWidth = 200,
  cardCount = 4,
  rowCount = 6,
}) {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label={label}
      aria-busy="true"
      className="grid gap-3"
    >
      <div className="skeleton skeleton-text--lg" style={{ width: headingWidth }} />
      <div className="skeleton skeleton-text" style={{ width: subheadingWidth }} />

      <div className="grid gap-3 md:grid-cols-2">
        {Array.from({ length: cardCount }).map((_, index) => (
          <div key={`skeleton-card-${index}`} className="skeleton skeleton-card" />
        ))}
      </div>

      <div className="rounded-xl border border-[var(--color-border)] p-3">
        {Array.from({ length: rowCount }).map((_, rowIndex) => (
          <div
            key={`skeleton-row-${rowIndex}`}
            className="skeleton"
            style={{ height: 30, marginBottom: rowIndex === rowCount - 1 ? 0 : 8 }}
          />
        ))}
      </div>
    </div>
  );
}

export default LoadingFallback;
